import { useEffect } from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { FAQ_ITEMS } from "@/content/site";
import { Reveal } from "@/components/Reveal";

const useFaqJsonLd = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-jsonld";
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQ_ITEMS.map((item) => ({
        "@type": "Question",
        name: item.question,
        acceptedAnswer: { "@type": "Answer", text: item.answer },
      })),
    });
    document.head.appendChild(script);
    return () => document.getElementById("faq-jsonld")?.remove();
  }, []);
};

const FaqColumn = ({ items, offset }) => (
  <Accordion type="single" collapsible>
    {items.map((item, i) => (
      <AccordionItem key={offset + i} value={`faq-${offset + i}`} className="border-b border-[#F0F0F0] py-2">
        <AccordionTrigger
          data-testid={`faq-trigger-${offset + i}`}
          className="text-lg md:text-xl font-medium text-[#252525] hover:text-[#B69A58] hover:no-underline transition-colors duration-300 text-left font-display"
        >
          {item.question}
        </AccordionTrigger>
        <AccordionContent data-testid={`faq-content-${offset + i}`} className="text-base text-[#4A4A4A] leading-relaxed pr-8">
          {item.answer}
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export const Faq = () => {
  useFaqJsonLd();
  const half = Math.ceil(FAQ_ITEMS.length / 2);
  const leftItems = FAQ_ITEMS.slice(0, half);
  const rightItems = FAQ_ITEMS.slice(half);

  return (
    <section id="caste-otazky" data-testid="faq-section" className="py-24 md:py-32 border-t border-[#F0F0F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <Reveal>
          <p className="flex items-center gap-4 text-xs uppercase tracking-[0.25em] text-[#737373] font-medium">
            <span className="w-10 h-[1px] bg-[#B69A58]" aria-hidden="true" />
            Časté otázky
          </p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.15] text-[#252525] mt-6 max-w-2xl">
            Na co se ptáte nejčastěji
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 grid lg:grid-cols-2 gap-x-16">
            <FaqColumn items={leftItems} offset={0} />
            <FaqColumn items={rightItems} offset={half} />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
